import dayjs from 'dayjs';
import { timeSegmentMaskKeys } from "./constants";
export var getTimeSegmentsFromDateString = function getTimeSegmentsFromDateString(dateTimeString, showSeconds, showMilliseconds) {
  var segments = {};

  if (dateTimeString) {
    var date = dayjs(dateTimeString.replace(/[a-zA-Z]/g, '0'));
    var showSegmentsLength = 2;

    if (showSeconds) {
      showSegmentsLength++;

      if (showMilliseconds) {
        showSegmentsLength++;
      }
    }

    Object.keys(timeSegmentMaskKeys).slice(0, showSegmentsLength).forEach(function (timeSegmentKey) {
      var functionKey = timeSegmentKey.substr(0, timeSegmentKey.length - 1);
      var segmentValue = date[functionKey]();
      segments[timeSegmentKey] = segmentValue || 0;
    });
  }

  return segments;
};
export var getTimeMaskPlaceholder = function getTimeMaskPlaceholder(dateMaskPlaceholder, _ref) {
  var showMilliseconds = _ref.showMilliseconds,
      showSeconds = _ref.showSeconds,
      showTime = _ref.showTime;
  var maskPlaceholder = dateMaskPlaceholder;

  if (showTime) {
    // No need to have RTL symbols in the mask as the component should be wrapped in an RTL context
    maskPlaceholder = "".concat(maskPlaceholder.replace(/\u200f/g, ''), " ").concat(timeSegmentMaskKeys.hours, ":").concat(timeSegmentMaskKeys.minutes);

    if (showSeconds) {
      maskPlaceholder += ":".concat(timeSegmentMaskKeys.seconds);

      if (showMilliseconds) {
        maskPlaceholder += ".".concat(timeSegmentMaskKeys.milliseconds);
      }
    }
  }

  return maskPlaceholder;
};